<template>
    <div class=" " style="margin: 0 26px;margin-bottom: 0!important;">
        <!-- <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                   
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                
            </el-form>
        </div> -->
        <div class="out_box">
            <div class="inner_box">
                <div class="header_tit">机构信息设置</div>
                <div class="body_box" :style="'height:'+heights">
                    <div class="l">
                        <div class="info1" style="margin-bottom:50px">
                            <div class="tits u-f u-ac u-jsb">
                                <div class="tit">登录账号信息：</div>
                                <div>
                                    <el-button style="color:#5473e8" @click="editpwd" type="text">修改</el-button>
                                </div>
                            </div>
                            <div class="info">
                                <div><span>用户名：</span>{{user.username}}</div>
                                <div><span>账号密码：</span>**********</div>
                            </div>
                        </div>
                        <div class="info1">
                            <div class="tits u-f u-ac u-jsb">
                                <div class="tit">机构基本信息：</div>
                                <div>
                                    <el-button style="color:#5473e8" @click="handleEdit()" type="text">修改</el-button>
                                </div>
                            </div>
                            <div class="info">
                                <div><span>机构简称：</span>{{datas.mcn_abbreviation}}</div>
                                <div><span>主体名称：</span>{{datas.mcn_name}}</div>
                                <div>
                                    <span>地址：</span>{{datas.province_code_text}}/{{datas.city_code_text}}/{{datas.area_code_text}}/{{datas.mcn_address}}
                                </div>
                                <div>
                                    <div>营业执照：</div>
                                    <div>
                                        <el-image class="yyzzimgs" v-for="(p,index) in datas.business_license_pic"
                                            :key="index" style="width: 150px; height: 150px" :src="p.url"
                                            :preview-src-list="[p.url]">
                                        </el-image>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="r">
                        <div class="info1">
                            <div class="tits u-f u-ac u-jsb">
                                <div class="tit">管理员信息：</div>
                                <div>
                                    <el-button style="color:#5473e8" @click="handleEdit()" type="text">修改</el-button>
                                </div>
                            </div>
                            <div class="info">
                                <div><span>管理员姓名：</span>{{datas.manager_name}}</div>
                                <div><span>管理员联系方式：</span>{{datas.manager_phone}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="修改账号密码" :visible.sync="pwddialogs" width="45%" top="120px" center class="dialogs"
            :close-on-click-modal='false' @close='closepwdedit'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <div class="tips">注：不填写新密码则不修改密码</div>
                <el-form ref="form" :model="pwdform" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-form-item label="用户名：">
                        <el-input v-model="pwdform.username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="原密码">
                        <el-input v-model="pwdform.oripwd" type="password" placeholder="请输入原密码"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码">
                        <el-input v-model="pwdform.password" show-password type="password" placeholder="请输入新密码">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="确认新密码">
                        <el-input v-model="pwdform.qrpassword" show-password type="password" placeholder="请输入确认新密码">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="pwdsubmit()" size="small" :loading='submitloading'>确 定</el-button>
                <el-button @click="pwddialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="修改" :visible.sync="dialogs" width="50%" top="100px" center class="dialogs" @close='closeedit'
            :close-on-click-modal='false'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="头像：" prop="pic_mapList">
                                <el-upload class="avatar-uploader" action="/admin/pc/fpUpload" name="img" :limit="1"
                                    ref="upload" :headers="{ }" :data="{ image_class_id:'2'}"
                                    :file-list="form.pic_mapList" :on-success="uploadSuccess" :on-remove="uploadRmove"
                                    list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                    <!-- verification:1,fileS:2,fileH:300,fileW:300  -->
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="机构简称：" prop="mcn_abbreviation">
                                <el-input v-model="form.mcn_abbreviation" size="small" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="主体名称：" prop="mcn_name">
                                <el-input v-model="form.mcn_name" size="small" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="机构地址：" required>
                                <div class=" u-f">
                                    <el-form-item prop="province_code" style="margin-right:10px">
                                        <el-select style="" v-model="form.province_code" placeholder="请选择" size="small"
                                            @change="getsq">
                                            <el-option v-for="item in sf_options" :key="item.code" :label="item.name"
                                                :value="item.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item prop="city_code" style="margin-right:10px">
                                        <el-select v-model="form.city_code" placeholder="请选择" size="small" clearable
                                            @change="getqy">
                                            <el-option v-for="item in sq_options" :key="item.code" :label="item.name"
                                                :value="item.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item prop="area_code" style="margin-right:10px">
                                        <el-select v-model="form.area_code" placeholder="请选择" size="small" clearable>
                                            <el-option v-for="item in qy_options" :key="item.code" :label="item.name"
                                                :value="item.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form-item>
                            <el-form-item label="机构详细地址：" prop="mcn_address">
                                <el-input v-model="form.mcn_address" size="small" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="社会统一信用码：" prop="business_license_code">
                                <el-input v-model="form.business_license_code" size="small" placeholder="请输入">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="营业执照：" prop="yyzz_mapList">
                                <el-upload class="avatar-uploader" action="/admin/pc/fpUpload" name="img" ref="upload"
                                    :headers="{ }" :data="{ image_class_id:'2'}" :file-list="form.yyzz_mapList"
                                    :on-success="uploadSuccess2" :on-remove="uploadRmove2" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                    <!-- verification:1,fileS:2,fileH:300,fileW:300  -->
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="管理员姓名：" prop="manager_name">
                                <el-input v-model="form.manager_name" size="small" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="管理员手机号：" prop="manager_phone">
                                <el-input v-model="form.manager_phone" size="small" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit('form')" size="small" class="tjben" :loading='submitloading'>确
                    定</el-button>
                <el-button @click="dialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                dialog: false,
                loading: false,
                heights: null,
                // 
                eid: '',
                sf_options: [],
                sq_options: [],
                qy_options: [],
                dialogs: false,
                form: {
                    user_name: '',
                    user_pwd: '',
                    province_code: '',
                    city_code: '',
                    area_code: '',
                    pic_mapList: [],
                    yyzz_mapList: [],
                    mcn_address: '',
                    mcn_name: '',
                    mcn_abbreviation: '',
                    business_license_code: '',
                    manager_name: '',
                    manager_phone: '',
                },
                rule: {
                    user_name: [{
                        required: true,
                        message: '请输入用户名',
                        trigger: 'blur'
                    }, ],
                    user_pwd: [{
                        required: true,
                        message: '请输入账号密码',
                        trigger: 'blur'
                    }, ],
                    mcn_name: [{
                        required: true,
                        message: '请输入主体名称',
                        trigger: 'blur'
                    }, ],
                    mcn_abbreviation: [{
                        required: true,
                        message: '请输入机构简称',
                        trigger: 'blur'
                    }, ],
                    province_code: [{
                        required: true,
                        message: '请选择省',
                        trigger: 'blur'
                    }, ],
                    city_code: [{
                        required: true,
                        message: '请选择市',
                        trigger: 'blur'
                    }, ],
                    area_code: [{
                        required: true,
                        message: '请选择区',
                        trigger: 'blur'
                    }, ],
                    business_license_code: [{
                        required: true,
                        message: '请输入社会统一信用码',
                        trigger: 'blur'
                    }, ],
                    manager_name: [{
                        required: true,
                        message: '请输入管理员姓名',
                        trigger: 'blur'
                    }, ],
                    manager_phone: [{
                        required: true,
                        message: '请输入管理员手机号',
                        trigger: 'blur'
                    }, ],
                    pic_mapList: [{
                        required: true,
                        message: '请上传头像',
                        trigger: 'blur'
                    }, ],
                    yyzz_mapList: [{
                        required: true,
                        message: '请上传营业执照',
                        trigger: 'blur'
                    }, ],
                    mcn_address: [{
                        required: true,
                        message: '请输入详细地址',
                        trigger: 'blur'
                    }, ],
                },
                submitloading: false,
                datas: '',
                business_license_pic: [],
                user_avatar: [],
                pwddialogs: false,
                pwdform: {
                    username: '',
                    oripwd: '',
                    password: '',
                    qrpassword: '',
                }


            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getsf()
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                that.heights = window.innerHeight - 240 + 'px'
                window.onresize = () => {
                    that.heights = window.innerHeight - 240 + 'px'
                }
            },
            begin() {
                this.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/manager/getMcnDetail", {

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.datas = response.data.data
                        this.getedit()
                    })
                    .catch(error => {})
            },
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let that = this
                        let arr = this.form
                        if (!/^1[3-9]\d{9}$/.test(arr.manager_phone)) return this.$message('手机号格式不正确')
                        this.submitloading = true
                        let params = {
                            mcn_name: arr.mcn_name,
                            mcn_abbreviation: arr.mcn_abbreviation,
                            mcn_address: arr.mcn_address,
                            manager_name: arr.manager_name,
                            manager_phone: arr.manager_phone,
                            province_code: arr.province_code,
                            city_code: arr.city_code,
                            area_code: arr.area_code,
                            business_license_code: arr.business_license_code,
                            business_license_pic: this.business_license_pic,
                            user_name: arr.user_name,
                            user_pwd: arr.user_pwd,
                            user_avatar: this.user_avatar,
                            is_update: 1
                        }
                        this.axios.post('/admin/pc/mcn/toExamine', params, {
                            token: true
                        }).then(res => {
                            this.submitloading = false
                            if (res.data.code == 200) {
                                this.$message.success('提交成功，请等待管理员审核')
                                that.dialogs = false
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        }).catch(err => {
                            this.submitloading = false
                        })
                    } else {
                        // this.$message('有必填项未填！')
                        return false;
                    }
                });

            },
            pwdsubmit() {
                if (this.pwdform.username == '') return this.$message('请输入用户名')
                if (this.pwdform.oripwd == '') return this.$message('请输入原密码')
                if (this.pwdform.password && (this.pwdform.password != this.pwdform.qrpassword)) return this.$message(
                    '密码不一致')
                this.submitloading = true
                let params = {
                    oripwd: this.pwdform.oripwd,
                    username: this.pwdform.username,
                    id: this.user.id,
                    password: this.pwdform.password,
                }
                this.axios.post('/admin/manager/changePwd', params, {
                    token: true
                }).then(res => {
                    this.submitloading = false
                    if (res.data.code == 200) {
                        this.$message.success('提交成功')
                        setTimeout(() => {
                            this.dialogs = false
                            this.$message("退出成功");
                            // 清除状态和存储
                            this.$store.commit("logout");
                            // 返回到登录页
                            this.$router.push({
                                name: "login",
                            });
                            this.$openws.ws.close();
                        }, 1000)
                    } else {
                        this.$message.error(res.data.msg)
                    }
                }).catch(err => {
                    this.submitloading = false
                })
            },
            getedit() {
                let that = this
                let d = that.datas
                this.form.pic_mapList = d.user_avatar
                this.user_avatar = d.user_avatar
                this.form.mcn_abbreviation = d.mcn_abbreviation
                this.form.mcn_name = d.mcn_name
                this.form.province_code = d.province_code + ''
                this.getsq()
                this.form.city_code = d.city_code + ''
                this.getqy()
                this.form.area_code = d.area_code + ''
                this.form.mcn_address = d.mcn_address
                this.form.business_license_code = d.business_license_code
                this.form.yyzz_mapList = d.business_license_pic
                this.business_license_pic = d.business_license_pic
                this.form.manager_name = d.manager_name
                this.form.manager_phone = d.manager_phone
            },
            handleEdit() {
                let that = this
                that.dialogs = true
            },
            editpwd() {
                this.pwdform.username = this.datas.user_name
                this.pwddialogs = true
            },
            closeedit() {
                this.getedit()
            },
            closepwdedit() {
                this.pwdform.oripwd = ''
                this.pwdform.password = ''
                this.pwdform.qrpassword = ''
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.user_avatar.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.user_avatar.findIndex(item => item.id == file.id)
                this.user_avatar.splice(index, 1)
            },
            uploadSuccess2(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.business_license_pic.push(response.data)
            },
            uploadRmove2(file, fileList) {
                var index = this.business_license_pic.findIndex(item => item.id == file.id)
                this.business_license_pic.splice(index, 1)
            },
            // 获取省份
            getsf() {
                let that = this
                axios
                    .post("/admin/h5/Area/getProvince_vue", {}, {
                        token: true
                    })
                    .then(response => {
                        that.sf_options = response.data.data
                    })
                    .catch(error => {})
            },
            getsq() {
                let that = this
                that.sq_options = []
                that.form.city_code = ''
                that.qy_options = []
                that.form.area_code = ''
                axios
                    .post("/admin/h5/Area/getChild_vue", {
                        parentcode: that.form.province_code,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.sq_options = response.data.data
                    })
                    .catch(error => {})
            },
            getqy() {
                let that = this
                that.qy_options = []
                that.form.area_code = ''
                axios
                    .post("/admin/h5/Area/getChild_vue", {
                        parentcode: that.form.city_code,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.qy_options = response.data.data
                    })
                    .catch(error => {})
            },

        },

    };
</script>
<style lang="scss" scoped>
    .tips {
        padding-left: 100px;
        margin-bottom: 32px;
        color: #000;
    }

    .out_box {
        // padding: 30px;
        background-color: #F8F9FA;

        .inner_box {
            background-color: #fff;
            border-radius: 6px;
            box-shadow: 0 0 4px 0 rgba($color: #a3a3a3, $alpha: .1);
        }

        .header_tit {
            padding: 20px;
            font-size: 16px;
            color: #252631;
            font-weight: 600;
            border-bottom: 1px solid #e7e7e7;
        }


        .body_box {
            display: flex;
            align-items: flex-start;
            padding-top: 15px;

            .l {
                min-height: 200px;
                width: 55%;
                border-right: 1px solid #e7e7e7;

                .info1 {
                    padding: 0 0px 0 20px;

                    .tits {
                        padding: 0 100px 15px 0px;

                        .tit {
                            font-size: 16px;
                            color: #778ca2;
                            font-weight: 600;
                        }
                    }

                    .info {
                        color: #a6b6c6;

                        div {
                            margin-bottom: 8px;
                        }

                        .yyzzimgs {
                            margin-right: 5px;
                        }
                    }
                }
            }

            .r {
                flex: 1;

                .info1 {
                    padding: 0 0px 0 20px;

                    .tits {
                        padding: 0 100px 15px 0px;

                        .tit {
                            font-size: 16px;
                            color: #778ca2;
                            font-weight: 600;
                        }
                    }

                    .info {
                        color: #a6b6c6;

                        div {
                            margin-bottom: 8px;
                        }
                    }
                }
            }
        }
    }

    .tjben {
        // background-color: #23bcca;
        // border-color: #23bcca;
    }

    /deep/.el-dialog__title {
        font-size: 16px !important;
    }

    /deep/.dialog-footer {
        .el-button--primary {
            background-color: #23bcca;
            border-color: #23bcca;
        }
    }
</style>